import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { About } from '../components/About';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-[#F5F1ED] font-sans selection:bg-[#D4AF37] selection:text-white" data-id="element-133">
      <Navigation data-id="element-134" />
      <main data-id="element-135">
        <Hero data-id="element-136" />
        <Services data-id="element-137" />
        <About data-id="element-138" />
        <Contact data-id="element-139" />
      </main>
      <Footer data-id="element-140" />
    </div>;
}